<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div v-if="!question.templateImageUrl">
      <div class="question-container">
        <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
        <div class="instruction_title ql-editor p-0 mb-20" v-html="question.formattedTitle"></div>
      </div>
      <div class="instruction_info ql-editor p-0" v-html="question.formattedInformation"></div>
      <div class="row mt-10">
        <div class="col-sm-6 col-md-6 col-lg-6">
          <div v-if="question.imageUrl">
            <img class="img-size" :src="question.imageUrl" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="pl-0 col-md-6 col-lg-6">
          <div class="question-container">
            <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
            <div class="instruction_title ql-editor p-0 mb-20" v-html="question.formattedTitle"></div>
          </div>
          <div class="instruction_info ql-editor p-0" v-html="question.formattedInformation"></div>
          <div v-if="question.imageUrl">
            <img class="img-size" :src="question.imageUrl" />
          </div>
        </div>
        <div class="col-md-6 col-lg-6">
          <div class="instruction_title ql-editor p-0">
            <p>Template Image</p>
          </div>
          <div v-if="question.templateImageUrl">
            <img class="img-size" :src="question.templateImageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="pt-20 screen-title">
      <div class="mb-15">
        <span class="example" @click="customCompletionModal()">Completion Screen Example</span>
      </div>
      <div class>Step title</div>
      <!-- <input type="text" class="form-control input-style br-2" placeholder="Enter title" v-model="question.title"> -->
      <quill-editor class="bg-white mb-30" v-model="question.formattedTitle" :options="editorOptionForInstruction"></quill-editor>
    </div>
    <div class="pt-20">
      <div class>Completion Message</div>
      <quill-editor class="instruction-screen bg-white mb-30" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption"></quill-editor>
    </div>
    <div class="row pt-20">
      <div class="pb-10">Image:</div>
      <div class="row">
        <div class="col-lg-2 pl-0 pr-20" v-if="question.imageUrl">
          <img class="img_size" :src="question.imageUrl" />
        </div>
        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 p-0">
          <div class="file_container1">
            <span class="file_container_text1">Upload</span>
            <input
              type="file"
              style="width: 100%"
              class="form-control-file"
              id="file_upload"
              accept="image/*"
              v-on:change="
                uploadCustomCompletionImage($event);
                return false;
              "
            />
          </div>
        </div>
        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
          <span class="pt-10 display-block color_898989">Recommended: 390px by 390px</span>
        </div>
      </div>
    </div>
    <div id="instructionModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content pt-15 pb-30 pl-30 pr-15">
          <div>
            <i class="fa fa-times cancelImage" aria-hidden="true" @click="closeModal()"></i>
          </div>
          <div class="pr-15 pt-20">
            <img src="static/img/custom-completion-example.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  name: "CustomCompletionScreen",
  components: {
    quillEditor
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {}
  },
  data() {
    return {
      editorOption: {
        placeholder: "This is a content for the last screen of this activity",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOptionForInstruction: {
        placeholder: "Enter Step title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      }
    };
  },
  methods: {
    customCompletionModal() {
      window.$("#instructionModal").modal("show");
    },
    uploadCustomCompletionImage(event, isInstructionTemplate) {
      const activityId = this.activityDetails.id;
      const self = this;
      const selectedImage = event.target.files[0];
      const input = window.document.getElementById("file_upload");
      if (input.files[0] && this.validateImage(input.files[0]) == null) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }
      const prevImageId = this.question && this.question.imageId ? this.question.imageId : "";
      const imageId = `img_id_${Math.random()
        .toString(36)
        .substr(2, 10)}`;
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: this.question.sequence,
          previousImageId: prevImageId,
          imageId: imageId,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(activityId, file, isInstructionTemplate).then(
          response => {
            if (response.data.result.imageUrl) {
              self.question.imageUrl = response.data.result.imageUrl;
              self.question.imageId = response.data.result.imageId;
            } else if (response.data.result.templateImageUrl) {
              self.question.templateImageUrl = response.data.result.templateImageUrl;
              self.question.templateImageId = response.data.result.templateImageId;
            }
            this.$toastr.success("Image uploaded successfully");
            if (isInstructionTemplate) {
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              window.$('#file_upload[type="file"]').val(null);
            }
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(self.errorMsg);
            if (isInstructionTemplate) {
              self.question.templateImageUrl = "";
              self.question.templateImageId = "";
              window.$('#template_file_upload[type="file"]').val(null);
            } else {
              self.question.imageUrl = "";
              self.question.imageId = "";
              window.$('#file_upload[type="file"]').val(null);
            }
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    validateImage(image) {
      const isValid = image.name.match(/.(png|jpg|svg)$/i);
      return isValid;
    },
    closeModal() {
      window.$("#instructionModal").modal("hide");
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      const title = this.stripHtml(question.formattedTitle);
      if (question.formattedTitle == undefined || title.length == 0) {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      const info = this.stripHtml(question.formattedInformation);
      if (question.formattedInformation == undefined || info.length == 0) {
        errorObj.isValid = false;
        errorObj.msg = "Please populate all the fields.";
        return errorObj;
      }
      return { isValid: true };
    }
  }
};
</script>

<style lang="scss" scoped>
.instruction_title {
  word-break: break-all;
  font-size: 18px;
  font-weight: bold;
}

.instruction_info {
  word-break: break-all;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}

.example {
  color: #4c8ce4;
  cursor: pointer;
}

.file_container1 [type="file"] {
  cursor: pointer;
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 100px;
  height: 40px;
  max-height: 50px;
  //   max-width: 200px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
  left: 0;
}
.file_container1 {
  margin-top: 5px;
  color: #555;
}
.file_container1 [type="file"] {
  cursor: pointer;
}
.file_container_text1 {
  background-color: #ddd;
  padding: 5px;
  width: 100%;
  display: block;
  border-radius: 4px;
  text-align: center;
}

.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}

.instruction-screen,
.instruction-screen .ql-editor {
  height: 180px;
}
</style>
